<template>
  <!-- Main content -->
  <section class="content" v-if="msal.isAuthenticated">
    <!-- GitHub hint -->
    <div class="row">

      <!-- Info boxes -->
      <!-- <div class="col-md-3 col-sm-6 col-xs-12">
        <info-box color-class="bg-aqua"
                  :icon-classes="['ion', 'ion-ios-people-outline']"
                  text="Nombre de clients"
                  number="230"></info-box>
      </div> -->
      <!-- /.col -->
      <!-- <div class="col-md-3 col-sm-6 col-xs-12">
        <info-box color-class="bg-red"
                  :icon-classes="['ion', 'ion-ios-cloud-upload-outline']"
                  text="Taux de réussite des backups"
                  number="99,2%"></info-box>
      </div> -->
      <!-- /.col -->

      <!-- fix for small devices only -->
      <div class="clearfix visible-sm-block"></div>
      
      <!-- <div class="col-md-3 col-sm-6 col-xs-12">
        <info-box color-class="bg-green"
                  :icon-classes="['ion', 'ion-ios-cart-outline']"
                  text="Sites Web Hébergés"
                  number="137"></info-box>
      </div> -->
      <!-- /.col -->
      <!-- <div class="col-md-3 col-sm-6 col-xs-12">
        <info-box color-class="bg-yellow"
                  :icon-classes="['ion', 'ion-ios-people-outline']"
                  text="Nouveaux clients ce mois-ci"
                  number="3"></info-box>
      </div> -->
      <!-- /.col -->
    </div>
    <!-- /.row -->

    <div class="container-fluid">
      <div class="box">
        <div class="box-header with-border">
          <div class="row">
            <div class="col-sm-5">
              <p class="text-center">
                <strong>État des Backups</strong>
              </p>
              <canvas id="backupPie"></canvas>
            </div>
            <div class="col-sm-5">
              <p class="text-center">
                <strong>Liste des postes</strong>
              </p>
              <div class="table-wrapper-scroll-y">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Poste</th>
                      <th scope="col">Dern. sauvegarde</th>
                      <th scope="col">Statut sauvegarde</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="packInstalled in listOfBackupPackInstalled"
                        v-bind:key="packInstalled.id"
                        v-bind:class="[backupAlarmLevel(packInstalled) === 'ERROR' ? 'text-danger' :
                                       backupAlarmLevel(packInstalled) === 'WARNING' ? 'text-warning' :
                                       backupAlarmLevel(packInstalled) === 'SUCCESS' ? 'text-success' :
                                       '']">
                      <th scope="row">{{ packInstalled.container.Name }}
                        <i>
                        [<span v-if="packInstalled.pack.Name === 'Sauvegarde locale'">local</span>
                          <span v-else-if="packInstalled.pack.Name === 'Sauvegarde sur serveur distant'">distant</span>
                          <span v-else-if="packInstalled.pack.Name === 'BackupHelper'">BHelper</span>
                          <span v-else>autre</span>]
                        </i>
                      </th>
                      <td>
                        {{ packInstalled.LastRunDateTime | moment("YYYY/MM/DD") }}
                      </td>
                      <td>
                        {{ packInstalled.LastRunResult }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="box-header with-border">
          <div class="row">
            <div class="col-sm-5">
              <p class="text-center">
                <strong>État des Services</strong>
              </p>
              <canvas id="servicemonitoringPie"></canvas>
            </div>
            <div class="col-sm-5">
              <p class="text-center">
                <strong>Liste des services</strong>
              </p>
              <div class="table-wrapper-scroll-y">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Service</th>
                      <th scope="col">Dernier signe de vie</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="serviceMonitoring in listOfservicemonitoring"
                        v-bind:key="serviceMonitoring.id"
                        v-bind:class="[servicemonitoringAlarmLevel(serviceMonitoring) === 'ERROR' ? 'text-danger' :
                                       servicemonitoringAlarmLevel(serviceMonitoring) === 'WARNING' ? 'text-warning' :
                                       servicemonitoringAlarmLevel(serviceMonitoring) === 'SUCCESS' ? 'text-success' :
                                       '']">
                      <th scope="row">{{ serviceMonitoring.ServiceName }}</th>
                      <td>
                        <div v-if="serviceMonitoring.TimeSinceLastHB - new Date().getTimezoneOffset() == 0">À l'instant</div>
                        <div v-else>{{ serviceMonitoring.TimeSinceLastHB - new Date().getTimezoneOffset() }} minutes</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /.row -->

    <!-- Main row -->
    <div class="row">
    </div>
    <!-- /.row -->
  </section>
  <!-- /.content -->
</template>

<script>
import Chart from 'chart.js'
import Alert from '../widgets/Alert'
import InfoBox from '../widgets/InfoBox'
import ProcessInfoBox from '../widgets/ProcessInfoBox'
import { mapGetters } from 'vuex'
import { msalMixin } from 'vue-msal'

export default {
  name: 'Dashboard',
  mixins: [msalMixin],
  components: {
    Alert,
    InfoBox,
    ProcessInfoBox
  },
  data: function () {
    return {}
  },
  computed: {
    ...mapGetters([
      'successpackinstalledCount',
      'warningpackinstalledCount',
      'errorpackinstalledCount',
      'allpackinstalledCount',
      'listOfBackupPackInstalled',
      'backupAlarmLevel',
      'successservicemonitoringCount',
      'warningservicemonitoringCount',
      'errorservicemonitoringCount',
      'allservicemonitoringCount',
      'listOfservicemonitoring',
      'servicemonitoringAlarmLevel',
      'isAdmin'
    ])
  },
  mounted () {
    this.$store.dispatch('fetchpackinstalledSauvegarde')
    this.displayPieChart()
    this.$store.dispatch('fetchservicemonitoring')
    this.displaySMPieChart()
  },
  watch: {
    successpackinstalledCount: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displayPieChart()
      }
    },
    warningpackinstalledCount: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displayPieChart()
      }
    },
    errorpackinstalledCount: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displayPieChart()
      }
    },
    allpackinstalledCount: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displayPieChart()
      }
    },
    successservicemonitoringCount: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displaySMPieChart()
      }
    },
    warningservicemonitoringCount: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displaySMPieChart()
      }
    },
    errorservicemonitoringCount: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displaySMPieChart()
      }
    },
    allservicemonitoringCount: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.displaySMPieChart()
      }
    }
  },
  methods: {
    displayPieChart () {
      var warningPct = Math.round((this.warningpackinstalledCount / this.allpackinstalledCount) * 100)
      var successPct = Math.round((this.successpackinstalledCount / this.allpackinstalledCount) * 100)
      var errorPct = Math.round((this.errorpackinstalledCount / this.allpackinstalledCount) * 100)
      var pieChartCanvas = document.getElementById('backupPie').getContext('2d')
      var pieConfig = {
        type: 'pie',
        data: {
          labels: [
            'Succès [' + this.successpackinstalledCount + ']',
            'Attention [' + this.warningpackinstalledCount + ']',
            'Erreur [' + this.errorpackinstalledCount + ']'
          ],
          datasets: [{
            data: [successPct, warningPct, errorPct],
            backgroundColor: ['#28a745', '#ffc107', '#dc3545'],
            hoverBackgroundColor: ['#28a745', '#ffc107', '#dc3545']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          }
        }
      }

      new Chart(pieChartCanvas, pieConfig) // eslint-disable-line no-new
    },
    displaySMPieChart () {
      var warningPct = Math.round((this.warningservicemonitoringCount / this.allservicemonitoringCount) * 100)
      var successPct = Math.round((this.successservicemonitoringCount / this.allservicemonitoringCount) * 100)
      var errorPct = Math.round((this.errorservicemonitoringCount / this.allservicemonitoringCount) * 100)
      var pieChartCanvas = document.getElementById('servicemonitoringPie').getContext('2d')
      var pieConfig = {
        type: 'pie',
        data: {
          labels: [
            'Succès [' + this.successservicemonitoringCount + ']',
            'Attention [' + this.warningservicemonitoringCount + ']',
            'Erreur [' + this.errorservicemonitoringCount + ']'
          ],
          datasets: [{
            data: [successPct, warningPct, errorPct],
            backgroundColor: ['#28a745', '#ffc107', '#dc3545'],
            hoverBackgroundColor: ['#28a745', '#ffc107', '#dc3545']
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          }
        }
      }

      new Chart(pieChartCanvas, pieConfig) // eslint-disable-line no-new
    },
    upperCase(value) {
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    }
  }
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
.table-wrapper-scroll-y {
  display: block;
  max-height: 300px;
  overflow-y: auto;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
/* Override bootstrap 4 table-striped to have odd lines lighter grayed (0.05 -> 0.03) */
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03);
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?77333989